// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';

import { CombinedState } from 'reducers';
import dimensions from 'utils/dimensions';
import RunTaskItemComponent from './run-task-item';

interface Props {
    runId: number;
}

export default function RunTaskListComponent({ runId }: Props): JSX.Element {
    const tasks = useSelector((state: CombinedState) => state.activeRun.tasks);
    const qaStates = useSelector((state: CombinedState) => state.activeRun.qaStates);

    return (
        <Row justify='center' align='top' className='cvat-run-task-list' style={{ marginTop: 16 }}>
            <Col {...dimensions}>
                {[...tasks].sort((a: any, b: any) => a.task_id - b.task_id).map((task: any) => (
                    <RunTaskItemComponent
                        key={task.task_id}
                        task={task}
                        runId={runId}
                        qaStates={qaStates}
                    />
                ))}
            </Col>
        </Row>
    );
}
